import React, { useState, useEffect, useContext } from 'react';
import { NavLink, Link, useNavigate, useLocation } from 'react-router-dom';
import policySamjhologo from '../assets/policySamjhologo.webp';
import { UserContext } from "../UserContext";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { UserId, user, UserToken, userRole, logout } = useContext(UserContext);
  const isLoggedIn = !!user && UserToken && userRole;
  const [dropdownOpen, setDropdownOpen] = useState({
    'our-services': false,
  });
  const [scrolled, setScrolled] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const navigateloginsignup = () => {
    navigate("/loginsignup");
  };
  const handleLogout = () => {
    logout();
    navigate("/home");
  };

  const isOurServicesActive = () => {
    const ourServicesLink = navLinks.find(link => link.id === 'our-services');
    if (ourServicesLink && ourServicesLink.dropdown && ourServicesLink.items) {
      return ourServicesLink.items.some(item => location.pathname === item.to);
    }
    return false;
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleDropdown = (dropdown) => {
    setDropdownOpen(prev => ({
      ...prev,
      [dropdown]: !prev[dropdown]
    }));
  };

  const dropdownTimeoutRef = React.useRef(null);

  const handleMouseEnterDropdown = (linkId) => {
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current);
      dropdownTimeoutRef.current = null;
    }
    if (navLinks.find(link => link.id === linkId)?.dropdown) {
      setDropdownOpen(prev => ({ ...prev, [linkId]: true }));
    }
  };

  const handleMouseLeaveDropdown = (linkId) => {
    if (navLinks.find(link => link.id === linkId)?.dropdown) {
      dropdownTimeoutRef.current = setTimeout(() => {
        setDropdownOpen(prev => ({ ...prev, [linkId]: false }));
      }, 150);
    }
  };

  const closeOurServicesDropdown = () => {
    setDropdownOpen(prev => ({ ...prev, 'our-services': false }));
  };

  const navLinks = [
    { id: 'home', label: 'Home', to: '/', dropdown: false },
    { id: 'about', label: 'About Us', to: '/about-us', dropdown: false },
    { id: 'buypolicies', label: 'Buy Policies', to: '/buy-policies', dropdown: false },
    { id: 'policylocker', label: 'Policy Locker', to: '/policy-locker', dropdown: false },
    { id: 'blog', label: 'Blogs', to: '/blog', dropdown: false },
    {
      id: 'our-services',
      label: 'Our Services',
      dropdown: true,
      items: [
        { id: 'lifeinsurance', label: 'Life Insurance', to: '/life-insurance-advice' },
        { id: 'healthinsurance', label: 'Health Insurance', to: '/health-insurance-guidance' },
        { id: 'homeinsurance', label: 'Home Insurance', to: '/home-insurance-explained' },
        { id: 'twowheelerinsurance', label: 'Two Wheeler Insurance', to: '/two-wheeler-insurance-advice' },
        { id: 'carInsurance', label: 'Car Insurance', to: '/car-insurance-consultation' },
        { id: 'cyberinsurance', label: 'Cyber Insurance', to: '/cyber-insurance-explained' },
        { id: 'shopkeeperinsurance', label: 'Shopkeeper Insurance', to: '/shopkeeper-insurance-advice' },
        { id: 'personalaccidentalinsurance', label: 'Personal Accidental Insurance', to: '/personal-accidental-insurance-guidance' },
        { id: 'criticalinsurance', label: 'Critical Insurance', to: '/critical-illness-insurance-consultation' },
        { id: 'insurancewithinvestment', label: 'Insurance with Investment', to: '/insurance-with-investment-advice' },
      ]
    },
  ];

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-500 bg-[#192437] backdrop-blur-lg shadow-lg py-2`}>
      <style>{`
        .mobile-dropdown-scroll::-webkit-scrollbar {
          width: 5px;
        }
        .mobile-dropdown-scroll::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .mobile-dropdown-scroll::-webkit-scrollbar-thumb {
          background: #F5A526;
          border-radius: 10px;
        }

        @media (max-width: 576px) {
          .xl\\:hidden > div {
            padding: 0.75rem 0.5rem !important;
          }
          .xl\\:hidden ul.flex.flex-col.gap-1 {
            gap: 0rem !important;
          }
          .xl\\:hidden ul.flex.flex-col.gap-1 > li > a,
          .xl\\:hidden ul.flex.flex-col.gap-1 > li > div > button {
            padding: 0.375rem 0.75rem !important;
            font-size: 0.8125rem !important;
          }
          .xl\\:hidden .overflow-y-auto ul.pl-6 {
            padding-left: 1rem !important;
            padding-top: 0.5rem !important;
            padding-bottom: 0.5rem !important;
          }
          .xl\\:hidden .overflow-y-auto ul.space-y-1 {
            gap: 0.25rem !important;
          }
          .xl\\:hidden .overflow-y-auto ul li a {
            padding: 0.3rem 0.6rem !important;
            font-size: 0.75rem !important;
            font-weight: 700 !important;
          }
          .xl\\:hidden .overflow-y-auto ul li a .w-1\\.5.h-1\\.5 {
            width: 0.4rem !important;
            height: 0.4rem !important;
            margin-right: 0.5rem !important;
          }
          .xl\\:hidden .overflow-y-auto ul li a .group-hover\\:w-3.group-hover\\:h-3 {
              width: 0.6rem !important;
              height: 0.6rem !important;
           }
          .xl\\:hidden .flex.flex-col.items-center.mt-6.space-y-4 {
            margin-top: 0.125rem !important;
            gap: 0.1rem !important;
          }
          .xl\\:hidden .text-gray-800.text-base.tracking-wide.font-semibold {
            font-size: 0.875rem !important;
          }
          .xl\\:hidden .flex.flex-col.items-center.mt-6.space-y-4 > button {
            height: 36px !important;
            padding-left: 0.8rem !important;
            padding-right: 0.8rem !important;
            font-size: 0.8125rem !important;
            width: 65% !important;
          }
          .xl\\:hidden .flex.flex-col.items-center.mt-6.space-y-4 > button svg {
            width: 1rem !important;
            height: 1rem !important;
            margin-right: 0.3rem !important;
          }
        }

        @media (min-width: 577px) and (max-width: 1024px) {
          .xl\\:hidden > div {
            padding: 0.8rem 0.6rem !important;
          }
          .xl\\:hidden ul.flex.flex-col.gap-1 > li > a,
          .xl\\:hidden ul.flex.flex-col.gap-1 > li > div > button {
            padding: 0.4rem 0.8rem !important;
            font-size: 0.9rem !important;
          }
          .xl\\:hidden .overflow-y-auto ul.pl-6 {
            padding-left: 1.2rem !important;
            padding-top: 0.6rem !important;
            padding-bottom: 0.6rem !important;
          }
          .xl\\:hidden .overflow-y-auto ul li a {
            padding: 0.35rem 0.7rem !important;
            font-size: 0.85rem !important;
          }
          .xl\\:hidden .flex.flex-col.items-center.mt-6.space-y-4 {
            margin-top: 0.75rem !important;
            gap: 0.5rem !important;
          }
          .xl\\:hidden .flex.flex-col.items-center.mt-6.space-y-4 > button {
            width: 60% !important;
          }
        }
      `}</style>
      <nav className="font-poppins w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          <div className="relative h-16 w-32 md:h-20 md:w-48">
            <img
              src={policySamjhologo}
              alt="Policy Samjho Logo"
              className={`size-full object-contain cursor-pointer transition-all duration-500 ${scrolled ? 'scale-90' : 'scale-100'}`}
            />
          </div>

          <div className="hidden xl:flex items-center flex-grow justify-center">
            <ul className="flex space-x-2">
              {navLinks.map((link) => (
                <li
                  key={link.id}
                  className="relative group"
                  onMouseEnter={() => handleMouseEnterDropdown(link.id)}
                  onMouseLeave={() => handleMouseLeaveDropdown(link.id)}
                >
                  {link.dropdown ? (
                    <>
                      <button
                        className={`px-3 py-2 font-medium transition-all duration-300 flex items-center relative no-underline ${dropdownOpen[link.id] || (link.id === 'our-services' && isOurServicesActive()) ? 'text-[#F5A526]' : 'text-white'} group-hover:text-[#F5A526]`}
                        onClick={() => toggleDropdown(link.id)}
                      >
                        <span className="relative z-10">{link.label}</span>
                        <svg
                          className={`ml-1 w-4 h-4 transition-transform duration-200 ${dropdownOpen[link.id] ? 'rotate-180' : ''}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                        <span className={`absolute -bottom-1 left-1/2 -translate-x-1/2 h-0.5 bg-[#F5A526] transform transition-all duration-300 origin-center ${dropdownOpen[link.id] || (link.id === 'our-services' && isOurServicesActive()) ? 'w-[calc(100%-2rem)]' : 'w-0 group-hover:w-[calc(100%-2rem)]'}`}></span>
                      </button>

                      <div
                        className={`absolute left-0 mt-2 w-72 rounded-xl shadow-xl bg-white/95 backdrop-blur-lg border border-gray-100 transition-all duration-300 origin-top ${dropdownOpen[link.id] ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 translate-y-1 pointer-events-none'}`}
                      >
                        <div className="py-2 px-1">
                          {link.items.map((item) => (
                            <NavLink
                              key={item.id}
                              to={item.to}
                              onClick={closeOurServicesDropdown}
                              className={({ isActive }) =>
                                `block px-4 py-2.5 text-sm text-gray-700 font-bold hover:bg-[#c87f0a] hover:text-white rounded-lg transition-all duration-200 relative overflow-hidden no-underline whitespace-nowrap ${isActive ? 'text-[#F5A526]' : ''}`
                              }
                            >
                              <span className="relative z-10 flex items-center">
                                <span className="w-2 h-2 rounded-full bg-[#F5A526] mr-3 transition-all duration-300 group-hover:w-3 group-hover:h-3"></span>
                                {item.label}
                              </span>
                              <span className="absolute inset-0 bg-yellow-100 opacity-0 hover:opacity-100 transition-opacity duration-300"></span>
                            </NavLink>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <NavLink
                      to={link.id === "policylocker" && !isLoggedIn ? "/loginsignup" : link.to}
                      className={({ isActive }) =>
                        `px-3 py-2 font-medium transition-all duration-300 relative block no-underline ${isActive ? 'text-[#F5A526]' : 'text-white'} group-hover:text-[#F5A526]`}
                      onClick={(e) => {
                        if (link.id === "policylocker" && !isLoggedIn) {
                          e.preventDefault();
                          navigate("/loginsignup", { state: { from: "/policy-locker" } });
                        }
                      }}
                    >
                      <span className="relative z-10">{link.label}</span>
                      <span
                        className={`absolute -bottom-1 left-1/2 -translate-x-1/2 h-0.5 bg-[#F5A526] transform transition-all duration-300 origin-center ${location.pathname === link.to ? 'w-[calc(100%-2rem)]' : 'w-0 group-hover:w-[calc(100%-2rem)]'}`}
                      ></span>
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="hidden xl:flex items-center space-x-4">
            {isLoggedIn ? (
              <>
                <span className="text-gray-300 text-base tracking-wide font-semibold">{user}</span>
                <button
                  className="relative flex items-center justify-center h-[44px] px-4 py-0 rounded-[91px] uppercase font-bold text-white bg-[#F5A526] shadow-md hover:shadow-lg hover:shadow-purple-300/50 transition-all duration-300 ease-in-out border-none cursor-pointer overflow-hidden hover:bg-[#F8BB5F] hover:scale-105"
                  onClick={handleLogout}
                >
                  <span className="relative z-10 flex items-center">
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m5-4v1a3 3 0 00-3 3v6a3 3 0 003 3h7" />
                    </svg>
                    Logout
                  </span>
                </button>
              </>
            ) : (
              <>
                <button
                  className="relative flex items-center justify-center h-[44px] px-4 py-0 rounded-[91px] uppercase font-bold text-white bg-[#F5A526] shadow-md hover:shadow-lg hover:shadow-purple-300/50 transition-all duration-300 ease-in-out border-none cursor-pointer overflow-hidden hover:bg-[#F8BB5F] hover:scale-105"
                  onClick={navigateloginsignup}
                >
                  <span className="relative z-10 flex items-center">
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                    </svg>
                    Login
                  </span>
                </button>
              </>
            )}
          </div>
          <div className="xl:hidden">
            <button
              onClick={toggleMenu}
              className="flex flex-col items-center justify-center w-12 h-12 focus:outline-none group"
              aria-label="Toggle menu"
            >
              <div className={`w-7 h-0.5 bg-[#F5A526] transition-all duration-300 ${isOpen ? 'rotate-45 translate-y-1.5' : 'mb-1.5 group-hover:bg-[#F8BB5F]'}`}></div>
              <div className={`w-7 h-0.5 bg-[#F5A526] transition-all duration-300 ${isOpen ? 'opacity-0' : 'mb-1.5 group-hover:bg-[#F8BB5F]'}`}></div>
              <div className={`w-7 h-0.5 bg-[#F5A526] transition-all duration-300 ${isOpen ? '-rotate-45 -translate-y-1.5' : 'group-hover:bg-[#F8BB5F]'}`}></div>
            </button>
          </div>
        </div>
        <div className={`xl:hidden ${isOpen ? 'block' : 'hidden'} transition-all duration-300 ease-in-out`}>
          <div className={`px-6 py-4 bg-white/95 backdrop-blur-lg rounded-xl mx-4 mt-3 shadow-2xl border border-gray-100 transition-all duration-500 ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'}`}>
            <ul className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <li key={link.id} className="relative">
                  {link.dropdown ? (
                    <div className="relative">
                      <button
                        onClick={() => toggleDropdown(link.id)}
                        className={`w-full flex justify-between items-center px-4 py-3 rounded-lg text-gray-700 hover:bg-yellow-50 hover:text-[#F5A526] font-medium transition-all duration-300 no-underline ${dropdownOpen[link.id] || (link.id === 'our-services' && isOurServicesActive()) ? 'text-[#F5A526]' : ''}`}
                      >
                        <span>{link.label}</span>
                        <svg
                          className={`ml-1 w-4 h-4 transition-transform duration-200 ${dropdownOpen[link.id] ? 'rotate-180' : ''}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      <div
                        className={`overflow-y-auto transition-all duration-500 ease-in-out mobile-dropdown-scroll ${dropdownOpen[link.id] ? 'max-h-[260px] opacity-100' : 'max-h-0 opacity-0'}`}
                      >
                        <ul className="pl-6 py-2 space-y-1">
                          {link.items.map((item) => (
                            <NavLink
                              key={item.id}
                              to={item.to}
                              onClick={() => {
                                setIsOpen(false);
                                closeOurServicesDropdown();
                              }}
                              className={({ isActive }) =>
                                `block px-4 py-2.5 rounded-lg text-gray-700 font-bold hover:bg-[#c87f0a] hover:text-white text-sm transition-all duration-200 flex items-center no-underline whitespace-nowrap ${isActive ? 'text-[#F5A526]' : ''}`
                              }
                            >
                              <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-[#F5A526] mr-3"></span>
                              {item.label}
                            </NavLink>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <NavLink
                      to={link.id === "policylocker" && !isLoggedIn ? "/loginsignup" : link.to}
                      onClick={(e) => {
                        setIsOpen(false);
                        if (link.id === "policylocker" && !isLoggedIn) {
                          e.preventDefault();
                          navigate("/loginsignup", { state: { from: "/policylocker" } });
                        }
                      }}
                      className={({ isActive }) =>
                        `block px-4 py-3 rounded-lg text-gray-700 hover:bg-[#c87f0a] hover:text-white font-medium transition-all duration-300 no-underline ${isActive ? 'text-[#F5A526]' : 'font-bold'}`}
                    >
                      {link.label}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
            {isLoggedIn ? (
              <div className="flex flex-col items-center mt-6 space-y-4">
                <span className="text-gray-800 text-base tracking-wide font-semibold">{user}</span>
                <button
                  className="w-full flex items-center justify-center h-[50px] px-4 py-0 rounded-[91px] uppercase font-bold text-white bg-[#F5A526] shadow-lg hover:shadow-[0_4px_20px_#000E29] transition-all duration-300 hover:bg-[#F8BB5F] hover:scale-105"
                  onClick={() => {
                    setIsOpen(false);
                    handleLogout();
                  }}
                >
                  <svg className="w-5 h-5 mr-2 group-hover:animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                  </svg>
                  Logout
                </button>
              </div>
            ) : (
              <div className="flex flex-col items-center mt-6 space-y-4">
                <button
                  className="w-full flex items-center justify-center h-[50px] px-4 py-0 rounded-[91px] uppercase font-bold text-white bg-[#F5A526] shadow-lg hover:shadow-[0_4px_20px_#000E29] transition-all duration-300 hover:bg-[#F8BB5F] hover:scale-105"
                  onClick={navigateloginsignup}
                >
                  <svg className="w-5 h-5 mr-2 group-hover:animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                  </svg>
                  Login
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;